import React from 'react';
import {useShowPreview} from '../../../data/hooks/ui';
import styles from './LayoutColumns.module.scss';

function LayoutColumns(props) {
    const { className='', count, filterPic, children} = props,
        showPreview = useShowPreview();

    return (
        <div className={`row ${styles.LayoutColumns}`}>
            <div className={[className, showPreview ? 'col-md-10' : 'col-md-12'].join(' ')}>{children}</div>
            {showPreview ? (
                <div className="col-md-2">
                    {count !== undefined ? (
                        <div className="preview">
                            {filterPic ? <div className={styles.filterPic}></div> : null}
                            {count}
                        </div>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
}

export default LayoutColumns;
